/*
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-28 13:29:53
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-22 11:36:05
 * @FilePath: /gamefi/common/js/betHelper.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useJoinStateStore } from '~/stores/cansino/joinState';
import {oAmountTips} from './constant'; 
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import type { FormObject } from '@/common/js/bettingToolkit/index';

/**
 * 计算最大下注金额
 * @param index 
 * @param sector Circle游戏中不同的下注颜色
 * @returns 最大下注金额
 */
export const getMaxBetAmout = (index: number = 1, sector?: string) => {
    const joinStateStore = useJoinStateStore();
    const settinsStore = useSettingsStore();
    let maxBets = joinStateStore.config[settinsStore.pickedCurrency]?.maxBets;
    // circle游戏中不同的 下注颜色 有不同的 最大下注金额
    // joinStateStore.hasGameInfoLoaded=true 表示游戏已切换完毕，并且join接口数据已加载更新
    if (joinStateStore.gameOfRoute === 'circleGame' && joinStateStore.hasGameInfoLoaded) {
        sector ||= 'gray';
        maxBets = joinStateStore.config[settinsStore.pickedCurrency]?.sectors[sector]?.maxBetAmount;
    }
    // 处理数组 如果數組中所有值都是相同的話，回傳第一個
    const arrayMaxBetsGetMaxBet = () => {
        const aValueArr = Object.values(maxBets);
        import.meta.dev && console.log('最大下注值為Object:', deepCopy(maxBets));
        // 如果數組中所有值都是相同的話，回傳第一個
        if (new Set(aValueArr).size === 1) {
            return aValueArr[0];
        }
        // 如果有default值，回傳default
        if (maxBets.default) {
            return maxBets.default;
        }
        // 如果沒有default值，回傳param index
        return maxBets[index];
    };
    const maxBetAmout = typeof maxBets === 'object' ? arrayMaxBetsGetMaxBet() : maxBets;
    return Number(maxBetAmout);
};

/**
 * 取得 “最小” 下注金额值
 * @param index 
 * @param sector Circle 游戏中不同的下注颜色
 * @returns 最小下注金额
 */
const getMinBetAmout = (sector?: string) => {
    const joinStateStore = useJoinStateStore();
    const settinsStore = useSettingsStore();
    let oConfig = joinStateStore.config?.[settinsStore.pickedCurrency] || {};
    if (joinStateStore.gameOfRoute === 'circleGame') {
        sector ||= 'gray';
        oConfig = oConfig.sectors?.[sector] || {};
    }
    // console.log("当前游戏，当前币种的下注配置信息：", deepCopy(oConfig)); 
    let { minBetAmount } = oConfig;
    if (!minBetAmount){
        console.warn("注意，未能成功查询最小下注金额，已经应用默认值 0.01", sector); 
        minBetAmount = 0.01; // 使用 0 还是 0.01 观察中 
    }
    // ↓ mini 版的下注金额只保留2位小数，因此不接受小于 0.01 的金额 
    // minBetAmount = Math.max(0.01, minBetAmount);
    if (import.meta.dev && minBetAmount < 0.01) {
        console.warn("最小下注金额小于 0.01，注意，需要修改!");
    }
    return minBetAmount;
};

/**
 * 下注金额x2
 * @param param0 
 * @returns 
 */
const onDoubleClick = ({
    currentBalance,
    minBetAmount,
    maxBetAmount,
    betAmount,
}: {
    currentBalance: number;
    minBetAmount?: number;
    maxBetAmount: number;
    betAmount: number;
}) => {
    minBetAmount ||= getMinBetAmout();
    if (currentBalance < minBetAmount) {
        return [currentBalance, oAmountTips.noMoneyPleaseCharge];
    }
    const dobuleAmount = betAmount * 2;
    // ↓ 目标值有效 
    if(dobuleAmount <= maxBetAmount){
        if (currentBalance >= dobuleAmount) { 
            return [dobuleAmount]; // 余额足够，应用目标值 
        }
        // ↓ 余额不足，应用余额  
        return [currentBalance, oAmountTips.reachedUserBalance];
    }
    else{
        // 至此，说明目标值无效（翻倍后大于下注上限值了） 所以这里以下注上限值为目标值  
        if (currentBalance >= maxBetAmount) { // 余额足够 
            return [maxBetAmount, oAmountTips.reachedUpperLimit]; 
        }
        // ↓余额不足，返回余额 
        return [currentBalance, oAmountTips.reachedUserBalance];
    }
    // ↓ 旧的，关停于 2025.05.08 13:18:18 星期四  
    // 添加currentBalance < maxBetAmount判断，否则会出现 当前下注金额 超过 最大下注金额 的情况
    // if (currentBalance < dobuleAmount && currentBalance < maxBetAmount) {
    //     return currentBalance;
    // } else if (dobuleAmount > maxBetAmount) {
    //     return maxBetAmount;
    // } else {
    //     return dobuleAmount;
    // }
};

/**
 * 点击获取最大下注金额
 * @param param0 
 * @returns 
 */
const onMaxClick = ({ 
    currentBalance,
    maxBetAmount,
    minBetAmount=0,
}) => {
    minBetAmount ||= getMinBetAmout();
    if (currentBalance < minBetAmount) {
        return [currentBalance, oAmountTips.noMoneyPleaseCharge];
    }
    if (currentBalance >= maxBetAmount){
        return [maxBetAmount];
    }
    return [currentBalance, oAmountTips.reachedUserBalance]; 
};

/**
 * 下注金额/2
 * @param currentBalance 
 * @param sector Circle 游戏中不同的下注颜色
 * @returns 
 */
const onHalfClick = (currentBalance, sector?: string) => {
    const userStore = useUserStore();
    const { balance = 0 } = userStore.oNowCurrency; // 用户的余额 
    const minBetAmount = getMinBetAmout(sector); // 最小下注值 
    // ↓ 钱不够下注，返回最小值（同默认金额的设定规则）
    if (balance < minBetAmount) {
        return [balance, oAmountTips.noMoneyPleaseCharge];
    }
    // ↓ 钱够，再细算 
    let finalValue = currentBalance / 2;
    let toast = '';
    if (finalValue < minBetAmount) { // 不可小于下注的下限
        finalValue = minBetAmount;
        toast = oAmountTips.reachedLowerLimit;
    }
    // ↓ 出于安全，先保留此行  
    finalValue = Math.max(0, finalValue);
    return [finalValue, toast]; 
};

// ↓检查用户是否“已经登录” （没登录则跳到提示页
export const checkIslogin = () => {
    const userStore = useUserStore();
    if (!userStore.isLoggedIn) {
        useNavigator('/information?key=notLoggedIn');
        return false;
    }
    return true;
};

// ↓ 检查用户是否“有余额” （应该检查余额是否 > 最小下注金额。光是检查“是否有余额” 没什么大用）
export const checkIfHasMoneny = () => {
    const userStore = useUserStore();
    const hasMoney = (
        Number(userStore.oNowCurrency.balance) > 0
    );
    return hasMoney;
}

// ↓ 检查用户是否“有余额” （没余额则弹出提示）
// ↓ 这是旧版，应改用新版 betableCheck() 
// ↓ 这旧版在查询用户是否有余额，没有意义，要查看这余额是否足够下注才对， 
export const checkMonenyIsEnough = () => {
    if (checkIfHasMoneny() === false) {
        const $t = useNuxtApp().$i18n.t;
        showNegativeNotify({
            message: $t('commonInfo.noBlance'),
        });
        return false;
    }
    return true;
}


// ↓ 取得默认下注金额
// ● 用户余额达到这个“默认值” 就在输入框放这个默认值
// ● 达不到就放 minbet （下注最小值） 
// ● 这是 2024-06-28 的商定的结论
const getCurrentDefaultBetAmount = () => {
    const joinStateStore = useJoinStateStore();
    const userStore = useUserStore();
    const { currencyName, balance } = userStore.oNowCurrency;
    if (currencyName === sCorgiCoin) return 100;
    const { defaultBet = 0, minBetAmount = 0 } = joinStateStore.config[currencyName];
    let value01 = 0;
    if (balance >= defaultBet) {
        value01 = defaultBet;
    } else {
        value01 = minBetAmount; // 甚至用户余额为0也放这个“最小下注金额” 
    }
    // ↓ 防止将 1.999 转为 2.0 而致下注报错 
    const value02 = Number(getFixed(value01, 2));
    return value02;
};

// ↓ 修改下注金额
// ↓ 通常用于金额输入框 blur 事件
const fixAmountValue = (
    sAmount: string = '', // 下注金额（input.value） 
): [string, string] => {
    const initialValue = Number(sAmount);
    let sFinalValue: string | number = 0;
    let toast = '';
    // ↓ 有值，则修剪值，防止超限 
    if (initialValue > 0) {
        const balance = useUserStore().oNowCurrency.balance || 0;
        const minBetAmount = getMinBetAmout();
        const maxBetAmount = getMaxBetAmout();
        if (balance < minBetAmount) { // 余额不足 
            sFinalValue = balance; 
            toast = oAmountTips.noMoneyPleaseCharge;
        }else if (initialValue < minBetAmount){ // 余额足，但输入值太小 
            sFinalValue = minBetAmount; 
            toast = oAmountTips.reachedLowerLimit; 
        }else if (initialValue > maxBetAmount){ // 输入值 > 上限 
            if (balance >= maxBetAmount){
                sFinalValue = maxBetAmount; // 余额充足，收缩到上限值 
                toast = oAmountTips.reachedUpperLimit;
            }else{ // 余额 < 上限 
                sFinalValue = balance; // 余额不足，数值收缩到用户余额 
                toast = oAmountTips.reachedUserBalance;
            }
        }else if (initialValue > balance){
            // 通过上方判断到达此处，可断定输入值 “没有” 超出投注上限值，仅超出余额 
            sFinalValue = balance; // 余额不足，数值收缩到用户余额 
            toast = oAmountTips.reachedUserBalance;
        }else{
            sFinalValue = initialValue;
            toast = ''; 
        }
    }
    // ↓ 无效值，填充默认值 
    else {
        sFinalValue = getCurrentDefaultBetAmount();
    }
    // ↓ 改为只要2位小数。是的，问过了，确认过了，只要2位小数，谢谢 
    sFinalValue = getFixed(Number(sFinalValue), 2);
    return [sFinalValue, toast];
}


// ↓ Mini 版中“新”的【点击下注验证方法】 （多合一形式，防止像旧版下注前要调用多个方法）
// ↓ 主要在点击【下注】按钮时调用此方法
// ↓ 1️⃣ 检测是否已经登录 => 没登录就跳到特定页
// ↓ 2️⃣ 检测金额是否合规 => 不合规就弹出提示，详情如下： 
// ↓ 2024-06-28 日有讨论结果：用户余额不足或0余额时【下注金额输入框】的默认金额是“最小下注金额” 
// ↓ 所以提交前要检测【下注金额输入框】的金额是否大于用户余额，检测不通过放弃提交，并弹出提示 
export const betableCheck = (
    betInfo?: number | FormObject,
    sector?: string,
): boolean => {
    const userStore = useUserStore();
    // ↓ 第1关，登录状态 ===============================================
    if (userStore.isLoggedIn == false) {
        useNavigator('/information?key=notLoggedIn'); // 跳到特定页面 
        return false;
    }
    const $t = useNuxtApp().$i18n.t;
    const oTips = {
        message: '',
    };
    const fBalance = Number(userStore.oNowCurrency.balance || 0);
    const fMin = getMinBetAmout(sector);
    const fMax = getMaxBetAmout(1, sector);
    // ↓ 第2关，用户余额的充足性检查 ===============================================
    if (fBalance < fMin) {
        oTips.message = $t('commonInfo.noBlance');
        showNegativeNotify(oTips as any);
        return false;
    }
    // ↓ 不传下注金额，这里就不进行判断，返回 True 表示可以下注
    if (typeof betInfo === 'undefined') {
        return true;
    }
    // ↓ 下注金额 
    const iAmount = (
        typeof betInfo === 'number'
            ? (betInfo || 0)
            : Number(betInfo.amount || 0)
    );
    // ↓ 第3关，下注金额合规性检查 ===============================================
    if (iAmount < fMin) {
        oTips.message = $t('commonInfo.amountTooLess', { min: fMin });
    } else if (iAmount > fMax) {
        oTips.message = $t('commonInfo.amountTooMuch', { max: fMax });
    }
    // ↓ 进入判断说明金额违规 
    if (oTips.message) {
        showNegativeNotify(oTips as any);
        return false;
    }
    // ↓ 通过所有检查，可以下注 
    return true;
}

/**
 *  按需提示用户下注金额非理性 
 *  @maxWin 当前奖金（用户期待的赔付金额；取自：下注金额 x 游戏最大返现倍数）
 */
export const showTips4BadAmountIfNeeded =(
    maxWin?: string | number,
) =>{
    if (!maxWin) return;
    const settinsStore = useSettingsStore();
    const joinStateStore = useJoinStateStore();
    // 根据币种获取当前最大赔付金额
    const config = joinStateStore.config[settinsStore.pickedCurrency];
    if (config?.maxWin > 0 == false) return; // 容错 
    if (import.meta.dev){
        console.log('当前游戏最大赔付：', deepCopy(config));
    }
    // 当前奖金大于当前最大赔付额，需要弹出提示  
    const toShowTips = Number(maxWin) > config.maxWin;
    if (!toShowTips) return;
    // 当前币种
    const currency = settinsStore.pickedCurrency.toUpperCase();
    const sMaxWin = number2LocaleString(config.maxWin);
    const { t: $tFn } = useNuxtApp().$i18n;
    const maxWinText = $tFn('commonInfo.payoutOverLimit', {
        limit: `${sMaxWin} ${currency}`,
    });
    showNegativeNotify({
        message: maxWinText,
        position: 'top', // 在顶部弹出，防止侵入用户操作  
        type: 'warning',
    });
}

export default {
    onHalfClick,
    onDoubleClick,
    onMaxClick,
    fixAmountValue,
    // -- ↑ 这些金额变动的方法需要返回相关提示信息 ---- 

    getMinBetAmout,
    getMaxBetAmout,
    checkIslogin,
    getCurrentDefaultBetAmount,
    checkMonenyIsEnough,
    checkIfHasMoneny,
    betableCheck,
    showTips4BadAmountIfNeeded,
};
